<template>
    <div class="p-alert">
      <div class="alert-main" v-for="item in notices" :key="item.name">
        <div :class="[item.status]" class="alert-content">
          <!-- <img class="a-icon" :src="'../../assets/images/qualityTracing/'+item.status+'.png'" alt=""> -->
          <img class="a-icon" src="../../assets/images/qualityTracing/success.png" alt="" v-if="item.status=='success'">
          <img class="a-icon" src="../../assets/images/qualityTracing/error.png" alt="" v-if="item.status=='error'">
          <span>{{item.content}}</span>
           <!-- {{item.status}} -->
        </div>
      </div>
    </div>
</template>

<script>
let seed = 0;

function getUuid() {
  return "alert_" + seed++;
}

export default {
  data() {
    return {
      notices: []
    };
  },
  methods: {
    add(notice) {
      const name = getUuid();

      let _notice = Object.assign(
        {
          name: name
        },
        notice
      );

      this.notices.push(_notice);

      // 定时移除，单位：秒
      const duration = notice.duration;
      setTimeout(() => {
        this.remove(name);
      }, duration);
    },
    remove(name) {
      const notices = this.notices;

      for (let i = 0; i < notices.length; i++) {
        if (notices[i].name === name) {
          this.notices.splice(i, 1);
          break;
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  .p-alert{
    z-index:9999999;
  }
  .alert-main{
    width: 100%;
    height: 100%;
    position:fixed;
    display:flex;
    align-items: center;
    justify-content: center;
    // left:0;
    // right:0;
    // top:0px;
    // bottom:0;
    z-index:9999999;
    background:rgba(0,0,0,.4);
    padding: 10%;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  
  .alert-content
    max-width: 50%;
    z-index:9999999;
    height:76px;
    display flex;
    align-items center;
    padding: 6px 20px 6px 25px;
    font-size 24px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  .error{
    color:#f34949;
    background: #fff1f1;
    border-radius:10px;
  }
  .success{
    color:#29a104;
    background: #f6fcf2;
    border-radius:10px;
  }
  .a-icon
    margin-right:20px;
  .alert
    position: fixed;
    width: 100%;
    top: 16px;
    left: 0;
    text-align: center;
    pointer-events: none;
  span
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
   
  
</style>
